'use client'

import { isNull } from 'lodash-es'
import { useTranslations } from 'next-intl'

import { useRouter } from '@/shared/i18n'
import { useSession } from '@/shared/lib'
import { Button } from '@/shared/ui'

import { PeriodTextButton } from './period-text-button'
import { DIALOG } from '../../lib/contract-dialog'
import {
  getRequestContractUrl,
  useContract,
} from '../side-panel/contract-information/provider'

type Props = {
  roomId: number
  disabled?: boolean
}

export const ContractActionArea = ({ roomId, disabled = false }: Props) => {
  const t = useTranslations('room_detail')

  const router = useRouter()
  const session = useSession()

  const { period, hasPeriodSelected, openDialog, getLastActiveContract } =
    useContract()

  const handleClick = async (forPeriod = false) => {
    const isBlockedUser = session?.data?.blocked

    if (isBlockedUser) {
      openDialog(DIALOG.BLOCKED_USER)

      return
    }

    const { success, data: contract } = await getLastActiveContract()

    if (!success) {
      return
    }

    if (forPeriod) {
      openDialog(DIALOG.PERIOD_CALENDAR)

      return
    }

    // 진행 중인 계약이 없는 경우 & 기간이 선택되지 않은 경우
    if (isNull(contract) && !hasPeriodSelected) {
      openDialog(DIALOG.PERIOD_CALENDAR)

      return
    }

    // 진행 중인 계약이 없는 경우 & 기간이 선택된 경우
    if (isNull(contract) && hasPeriodSelected) {
      router.push(
        getRequestContractUrl({
          roomId,
          dateRange: { from: period?.from, to: period?.to },
        }),
      )

      return
    }

    if (contract?.isExtendContractAvailable) {
      // 확정된 계약이 있는 경우 (연장 가능한 경우)
      openDialog(DIALOG.CHECK_EXTEND_CONTRACT)
    } else {
      // 계약 대기 상태의 계약이 있는 경우
      openDialog(DIALOG.IN_PROGRESS_CONTRACT)
    }
  }

  return (
    <div className="space-y-4 px-6 text-center">
      <PeriodTextButton
        onClick={() => handleClick(true)}
        period={period}
        disabled={disabled}
      />
      <Button
        size="large"
        fullWidth
        onClick={() => handleClick(false)}
        disabled={disabled}
        {...(!disabled && {
          style: {
            background:
              'linear-gradient(90deg, rgba(78, 144, 249, 0.00) 0%, #4E90F9 100%), var(--Purple-purple-500, #895FFC)',
          },
        })}
      >
        {t('button.start_contract')}
      </Button>
    </div>
  )
}
